import { UserCheck, CalendarDays, IndianRupee, Building2 } from "lucide-react";

export const TrustStrip = ({ stats }) => {
  const items = [
    {
      icon: UserCheck,
      title: "Human-checked bays",
      body: "We call the host, match the photos, and visit big sites in person.",
    },
    {
      icon: CalendarDays,
      title: "Monthly, not hourly",
      body: `One month minimum, ${stats.cancellation_notice_days} days' notice to leave. No daily juggling.`,
    },
    {
      icon: IndianRupee,
      title: `₹${stats.platform_fee_inr} flat platform fee`,
      body: "That's our entire cut from a booking. GST included.",
    },
    {
      icon: Building2,
      title: "A company you can find",
      body: "Sahasamstapaka Private Limited, Jayanagar, Bengaluru. GSTIN on every invoice.",
    },
  ];

  return (
    <section data-testid="trust-strip" className="border-b border-line bg-surface2">
      <div className="nb-shell grid gap-px py-0 sm:grid-cols-2 lg:grid-cols-4">
        {items.map(({ icon: Icon, title, body }, i) => (
          <div
            key={title}
            data-testid={`trust-item-${i}`}
            className="border-line px-0 py-7 sm:px-6 lg:border-l lg:first:border-l-0"
          >
            <Icon size={20} className="text-brand" aria-hidden="true" />
            <h3 className="mt-3 text-base">{title}</h3>
            <p className="mt-2 text-sm text-ink3">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
